import Products from './Products.view';

export default Products;
